import { useReducer, createContext } from 'react';
import { sviThemes } from './SVIThemeModel';
import { scopeList, tractList, staticYearList, tabList, statesList } from './StaticVariables';
import produce from 'immer';
import TEXTS from '../controller/TextVariables';
import { readErrorMesssage, findCenter } from './DataTransformation';
export const InterfaceContext = createContext();

const infoWindow_init = {
    feature: null,
    pinned: false
};
//ΔVΔVΔ: UI Context Variables
const interface_init = {
    usState: false,
    downloadRegion: false,
    scope: scopeList[0],
    // scope: scopeList[1],
    // usState: statesList.find((st) => st.abbr === 'GA'),
    // tract: tractList[1],
    tract: tractList[0],
    geometry: tractList[0],
    theme: sviThemes[0],
    year: staticYearList[0],
    search: '',
    tab: window.location.hash.indexOf('#more') !== -1 ? tabList[2] : tabList[0],
    // tab: tabList[1],
    opacity: 100,
    hhsregion: 0,
    streetmap: 1,
    openMenu: true,
    map: null, //ΔVΔVΔ: Temprarily here to get download working
    hospital: 0,
    daycare: 0,
    school: 0,
    nursinghome: 0,
    infoWindows: [],
    selectedFeature: null,
    hoveredFeature: null,
    selectedFeatureIsPinned: false,
    download_modal: false,
    darkMode: false,
    censusEnabled: false,
    errorMessage: '',
    err: '',
    message: '',
    isResizing: '',
    tableData: null,
    printPDF: false,
    fipsInView: [],
    tempState: null,
    highlightedFips: null,
    loadStatus: 1,
    marker: { center: [] },
    compareExtent: [-17426261.63232968, 1792316.2485397668, -4521245.272886802, 7897494.571733365],
    preparedMapState: false,
    preparedMapCounty: false
};
// ΔVΔVΔ: UI Context Methods
const uiActions = (state, dispatch) => {
    return {
        setSelectedFeature: (value) => dispatch({ type: 'setSelectedFeature', value }),
        setHHS: () => dispatch({ type: 'setHHS', value: !state.hhs }),
        setStreets: (value) => dispatch({ type: 'setStreets', value: !state.streetmap }),
        setHospitals: () => dispatch({ type: 'setHospitals', value: !state.hospitals }),
        setDaycare: () => dispatch({ type: 'setDaycare', value: !state.daycare }),
        setSchools: () => dispatch({ type: 'setSchools', value: !state.schools }),
        setNursing: () => dispatch({ type: 'setNursing', value: !state.nursing }),
        setSelectedState: (value) => dispatch({ type: 'setSelectedState', value }),
        setDownloadRegion: (value) => dispatch({ type: 'setDownloadRegion', value }),
        setSelectedScope: (value) => dispatch({ type: 'setSelectedScope', value }),
        setSelectedTract: (value) => dispatch({ type: 'setSelectedTract', value }),
        setSelectedTheme: (value) => dispatch({ type: 'setSelectedTheme', value }),
        setSelectedCounty: (value) => dispatch({ type: 'setSelectedCounty', value }),
        setSelectedYear: (value) => dispatch({ type: 'setSelectedYear', value }),
        setThemeOpacity: (value) => dispatch({ type: 'setThemeOpacity', value }),
        setSearch: (value) => dispatch({ type: 'setSearch', value }),
        setStateSearch: (value) => dispatch({ type: 'setStateSearch', value }),
        unsetSearch: () => dispatch({ type: 'unsetSearch' }),
        unsetMarker: () => dispatch({ type: 'unsetMarker' }),
        loadEnd: () => dispatch({ type: 'loadEnd' }),
        doReset: () => dispatch({ type: 'reset' }),
        doResetZoom: () => dispatch({ type: 'resetZoom' }),
        setToggle: (name) => dispatch({ type: 'setToggle', name: name, value: !state[name] }),
        setSelectedTab: (value) => dispatch({ type: 'setSelectedTab', value }),
        setinfobox: (feature, pixel) => dispatch({ type: 'setinfobox', feature, pixel }),
        unsetinfobox: () => dispatch({ type: 'unsetinfobox' }),
        addInfoWindow: (feature, pixel) => dispatch({ type: 'addInfoWindow', feature, pixel }),
        removeInfoWindow: (index) => dispatch({ type: 'removeInfoWindow', index }),
        moveInfoWindow: (pixel) => dispatch({ type: 'moveInfoWindow', pixel }),
        moveHoveredFeature: (pixel) => dispatch({ type: 'moveHoveredFeature', pixel }),
        updateInfoWindow: (feature, pixel) => dispatch({ type: 'updateInfoWindow', feature, pixel }),
        pinInfoWindow: (index) => dispatch({ type: 'pinInfoWindow', index }),
        setMode: () => dispatch({ type: 'setMode' }),
        updatePinnedFeature: (feature) => dispatch({ type: 'updatePinnedFeature', feature }),
        updateHoveredFeature: (feature, pixel) => dispatch({ type: 'updateHoveredFeature', feature, pixel }),
        pinWindow: (value) => dispatch({ type: 'pinWindow', value }),
        showDownloadModal: () => dispatch({ type: 'toggleDownloadModal', value: true }),
        closeDownloadModal: () => dispatch({ type: 'toggleDownloadModal', value: false }),
        setMessage: (value) => dispatch({ type: 'setMessage', message: value }),
        setErrorMessage: (value, err = false) => dispatch({ type: 'setErrorMessage', value, err }),
        setIsResize: (value) => dispatch({ type: 'setIsResize', value }),
        setTableData: (value) => dispatch({ type: 'setTableData', value }),
        setCensusEnabled: (value) => dispatch({ type: 'setCensusEnabled', value }),
        enableCensus: (value) => dispatch({ type: 'enableCensus', value }),
        setIMap: (value) => dispatch({ type: 'setIMap', value }),
        setFipsInView: (value) => dispatch({ type: 'setFipsInView', value }),
        setForceMap: (value) => dispatch({ type: 'setForceMap', value }),
        setTempState: (value) => dispatch({ type: 'setTempState', value }),
        setHighlightedFips: (value) => dispatch({ type: 'setHighlightedFips', value }),
        setCompareExtent: (value) => dispatch({ type: 'setCompareExtent', value }),
        setLoadStatus: (value) => dispatch({ type: 'setLoadStatus', value }),
        setOpenMenu: (value) => dispatch({ type: 'setOpenMenu', value }),
        setPreparedMapChoice: (value) => dispatch({ type: 'setPreparedMapChoice', value })
    };
};
function switchDCTract(scope, usstate, tract) {
    // console.log('===> ', ' SCOPE: ',scope,' STATE',usstate?.id,' TRACT: ',tract)
    return usstate?.id + '' === '11' && scope === 'state' && tract === 'county';
}
// ΔVΔVΔ: UI Context State Transformation
function interfaceReducer(state, action) {
    let shouldSwitchTract, tract, usState, message;
    switch (action.type) {
        case 'setSelectedFeature':
            return { ...state, selectedFeature: action.value };
        case 'setSelectedTract':
            shouldSwitchTract = switchDCTract(state.scope, state.usState, action.value);
            tract = shouldSwitchTract ? 'census' : action.value;
            message = shouldSwitchTract ? TEXTS.modals.autoSwitchDCtract.text : action.message;
            return { ...state, tract, message };
        case 'setSelectedScope':
            usState = action.value === 'national' ? false : state.usState;
            shouldSwitchTract = switchDCTract(action.value, usState, state.tract);
            tract = shouldSwitchTract ? 'census' : state.tract;
            message = shouldSwitchTract ? TEXTS.modals.autoSwitchDCtract.text : action.message;
            return { ...state, scope: action.value, usState, tract, message };
        case 'setTempState':
            return { ...state, tempState: action.value };
        case 'setSelectedTheme':
            return { ...state, theme: action.value };
        case 'setComparedExtent':
            return { ...state, compareExtent: action.value };
        case 'setOpenMenu':
            return { ...state, openMenu: action.value };
        case 'setToggle':
            const obj = {};
            obj[action.name] = action.value;
            return { ...state, ...obj };
        case 'setHHS':
            return { ...state, hhsregion: action.value };
        case 'setHospitals':
            return { ...state, hospital: action.value };
        case 'setDaycare':
            return { ...state, daycare: action.value };
        case 'setSchools':
            return { ...state, school: action.value };
        case 'setNursing':
            return { ...state, nursing: action.value };
        case 'setSelectedState':
            shouldSwitchTract = switchDCTract(state.scope, action.value, state.tract);
            tract = shouldSwitchTract ? 'census' : state.tract;
            message = shouldSwitchTract ? TEXTS.modals.autoSwitchDCtract.text : action.message;
            return { ...state, usState: action.value, tract, message };
        case 'setDownloadRegion':
            return { ...state, downloadRegion: action.value, message };
        case 'setThemeOpacity':
            return { ...state, opacity: action.value };
        case 'setSelectedYear':
            var themeObj = { ...state.theme };
            themeObj.label = action.value.label + '' === '2020' ? state.theme.label2020 : state.theme.labelPast;
            return { ...state, year: action.value, theme: themeObj };
        case 'UIload':
            return { ...state, isLoading: true };
        case 'UIloadEnd':
            return { ...state, isLoading: false };
        case 'setSelectedTab':
            return { ...state, tab: action.value };
        case 'setStreets':
            return { ...state, streetmap: action.value };
        case 'setMap':
            let newContent = Object.assign({}, state.content, {
                map: action.value
            });
            return { ...state, content: newContent };
        case 'reset':
            return {
                ...state,
                ...interface_init,
                tab: state.tab,
                search: ''
            };
        case 'setSearch':
            return {
                ...state,
                search: action.value,
                marker: {
                    center: findCenter([action.value.slice(0, 2), action.value.slice(2)])
                }
            };
        case 'setStateSearch':
            return {
                ...state,
                search: action.value,
                marker: {
                    center: []
                }
            };
        case 'unsetMarker':
            return { ...state, marker: interface_init.marker };
        case 'unsetSearch':
            return { ...state, search: '', marker: interface_init.marker };
        case 'setMode':
            return { ...state, darkMode: !state.darkMode };
        case 'setTableData':
            return { ...state, tableData: action.value };
        case 'updatePinnedFeature':
            return { ...state, selectedFeature: action.feature };
        case 'updateHoveredFeature':
            return { ...state, hoveredFeature: action.feature };
        case 'pinWindow':
            return { ...state, selectedFeatureIsPinned: action.value };
        case 'toggleDownloadModal':
            return { ...state, download_modal: action.value };
        case 'setMessage':
            return { ...state, message: action.message };
        case 'setErrorMessage':
            return {
                ...state,
                errorMessage: readErrorMesssage(action.value, action.err)
            };
        case 'setIsResize':
            return { ...state, isResizing: action.value };
        case 'setCensusEnabled':
        case 'enableCensus':
            const newState = {
                ...state,
                censusEnabled: action.value,
                tract: action.value ? state.tract : tractList[0]
            };
            if (state.censusEnabled && action.value === false) {
                if (state.tab.slug === 'map' && state.tract === 'census') {
                    newState.message = TEXTS.modals.autoSwitchCensus.text;
                }
            }
            return newState;
        case 'setIMap':
            return { ...state, map: action.value };
        case 'setFipsInView':
            return { ...state, fipsInView: action.value };
        case 'setHighlightedFips':
            return { ...state, highlightedFips: action.value };
        case 'setLoadStatus':
            return { ...state, loadStatus: action.value };
        case 'setPreparedMapChoice':
            // console.log(action.value);
            // return state;
            return {
                ...state,
                tab: tabList[2],
                preparedMapState: action.value.usstate,
                preparedMapCounty: action.value.county
            };
        default:
            return state;
    }
}

const InterfaceProvider = ({ children }) => {
    const [state, dispatch] = useReducer(interfaceReducer, interface_init);
    const value = {
        ...state,
        ...uiActions(state, dispatch)
    };
    return <InterfaceContext.Provider value={value}>{children}</InterfaceContext.Provider>;
};
export { InterfaceProvider };
